import React, { Component } from 'react'
import connect from "react-redux/es/connect/connect";
import PropTypes from 'prop-types';
import { Spin, message } from 'antd';

import Events from '../../services/events.js';
import { like } from '../../services/firebase/firebase';
import { deleteEventAction } from "../../actions/eventsStoreActions";
import { addChannelAction } from "../../actions/channelsStoreActions";

import ChannelList from '../../components/Modules/ChannelList';
import EventList from '../../components/Modules/EventList';

import SectionNoData from './SectionNoData';

import './feed.less';

const defaultPlaceholderImage = "https://firebasestorage.googleapis.com/v0/b/implant-compare.appspot.com/o/images%2Fplaceholder.png?alt=media&token=18740d81-a9cd-4c0c-b98e-8f93cb4fa52c"

message.config({
  top: 65,
  duration: 2,
  maxCount: 3,
});

class Feed extends Component {
  constructor(props) {
    super(props);

    this.channels = [];
    this.state = {
      loading: true,
      savingEvent_id: null
    };
  }

  updateSaveEventId = (id) => {
    this.setState({ savingEvent_id: id});
  }

  saveNewListItem = this.props.renderType === "channels" ? this.saveNewChannel : this.saveNewEvent;

  async handleDeleteEvent(event) {
    this.props.deleteEventAction(event).then((res) => {
      res === "success" && this.setState({ loading: false })
    })
  }

  createNewChannel() {
    this.setState({
      newChannel: {
        newElement: true,
        title: 'New item',
        author: '',
        description: '',
        thumbnail: defaultPlaceholderImage
      }
    })
  }

  saveNewChannel(changesDiscarded) {
    if (!changesDiscarded) {
      delete this.state.newChannel.newElement;

      this.setState({newElement: {}})
      this.props.addChannelAction(this.state.newChannel)
    }

    this.setState({newChannel: {}})
  }

  // ===== GENERAL ===== //

  renderFeed(events) {
    const eventType = this.props.eventType ? this.props.eventType : 'all';
    Events.setFilter('events', eventType);

    // return this.renderSection( Events.filterList(events)); // filter for upcoming
    return this.renderSection( events);
  }

  renderSection(list) {
    const { eventType, user, data, pageType, location } = this.props;
    const { userClaims } = user;
    const { eventsLoading } = data;
    list = eventType === "upcoming" ? (
        list.sort(function(a,b) {
          return new Date(a.date) - new Date(b.date);
        })
      )
       : (
         list.sort(function(a,b) {
          return new Date(b.date) - new Date(a.date);
        })
      );

    return (
      <div>
        {(list && list.length > 0 && !eventsLoading) && (
          <EventList
            userClaims={userClaims}
            events={list}
            pageType={pageType}
            handleDeleteEvent={this.handleDeleteEvent}
            handleLike={this.handleLike}
            pathFrom={location.pathname}
            savingEvent_id={this.state.savingEvent_id}
            updateSaveEventId={this.updateSaveEventId}
            user={user}
          />
        )}

        {eventsLoading && <Spin className="preloader"/>}
          {(!eventsLoading && !(list && list.length > 0)) && <div className="info-message-no-date"><SectionNoData location={location}/></div>}
        {/* {!(list && list.length > 0 && !eventsLoading) && <Spin className="preloader"/>} */}
      </div>
    )
  }

  async handleLike(item) {
    try { await like(item.id) }
    catch (err) {
      console.error(err);
      if (err.toString() === "TypeError: Failed to fetch") message.error("Server does not respond, try again later")
    }
  }

  render() {
    const { list, data } = this.props;
    const { events, subscriptions } = data;

    list.map(item => {
      item.eventsNumber = events && events.filter(event => event.channel && event.channel.id === item.id).length;
    });

    let sortedList = list.sort((a, b) => {
      return b.eventsNumber - a.eventsNumber; // descending sort
    });

    return (
      <div className="feed">
        {
          this.props.renderType === "events" && list && this.renderFeed(list)
        }
        {
          this.props.renderType === "channels" && (
            <div>
              {
                (list.length > 0) ?
                  <ChannelList
                    data={sortedList}
                    pathFrom={this.props.location.pathname}
                    pageType={this.props.pageType}
                    events={events}
                    subscriptions={subscriptions}
                  />
                  :
                  <Spin className="preloader" />
              }
            </div>
          )
        }
      </div>
    )
  }
}

Feed.propTypes = {
  renderType: PropTypes.string
};

export default connect(
  (state) => {
    return { data: state.data, user: state.user };
  },
  { deleteEventAction, addChannelAction }
)(Feed);



// WEBPACK FOOTER //
// ./src/pages/Feed/index.js